import {
    GeoLocationErrorCode,
    GeoPermissionState,
    GeoVault,
} from './types';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { getConfig } from '@superbet-group/web.lib.config';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { ClickName } from '@superbet-group/product.analytics';

export function writeLastGeoLocationPingTime() {
    const now = new Date();
    sessionStorage.setItem('lastGeoLocationPingTime', now.toISOString());
}

export function getTimePassedSinceLastGeoLocationPing(): number | null {
    const lastPingTime = sessionStorage.getItem('lastGeoLocationPingTime');
    if (!lastPingTime) {
        return null;
    }
    const lastPingDate = new Date(lastPingTime);
    const now = new Date();
    return now.getTime() - lastPingDate.getTime();
}

export async function getIsUsingGeoLocationCheck(): Promise<boolean> {
    if (!getConfig().environment.isProdEnvironment && localStorage.getItem('disableGeoLocationCheck') === 'true') {
        return false;
    }
    return await featureFlagService.getFeatureValueWithTimeout('web.geo_location_check', false, 1000);
}

export function getGeoLocationErrorCode(geoVault: GeoVault): GeoLocationErrorCode {
    let code: GeoLocationErrorCode;
    switch (geoVault.failureCode) {
        case '8.3':
            code = GeoLocationErrorCode.PermissionError;
            break;
        case '10':
            if (geoVault.type === 'NO_LOCATION') {
                if (geoVault.geoReason === 'POS') {
                    code = GeoLocationErrorCode.UnableToGetLocation;
                } else if (geoVault.geoReason === 'DENIED') {
                    code = GeoLocationErrorCode.PermissionError;
                } else {
                    code = GeoLocationErrorCode.GenericError;
                }
            } else {
                code = GeoLocationErrorCode.GenericError;
            }
            break;
        case '10.1':
            code = GeoLocationErrorCode.DevTools;
            break;
        case '10.2':
            code = GeoLocationErrorCode.VpnUsage;
            break;
        default:
            code = GeoLocationErrorCode.GenericError;
            break;
    }
    return code;
}

export async function getGeoLocationActualPermission() {
    if (!navigator.permissions || !navigator.permissions.query) {
        return GeoPermissionState.GRANTED;
    }
    try {
        const geoPermissionState = await navigator.permissions.query({ name: 'geolocation' });
        if (navigator.userAgent.indexOf('Chrome') !== -1) {
            switch (geoPermissionState.state) {
                case 'granted':
                    return GeoPermissionState.GRANTED;
                case 'denied':
                    return GeoPermissionState.DENIED;
                case 'prompt':
                    return GeoPermissionState.PROMPT;
                default:
                    return GeoPermissionState.GRANTED;
            }
        } else {
            return geoPermissionState.state === 'denied' ? GeoPermissionState.DENIED : GeoPermissionState.GRANTED;
        }
    } catch (error) {
        return GeoPermissionState.GRANTED;
    }
}

export function emitGeoLocationEvent(
    clickName: string,
    clickValue1?: string,
    clickValue2?: string,
    clickValue3?: string,
    clickValue4?: string,
    clickValue5?: string,
) {
    AnalyticsSDK.getInstance().log('click', {
        click_name: ClickName.CLICK_NAME_UNSPECIFIED,
        click: {
            click_name: clickName,
            type: 'test_click',
            click_value_1: clickValue1,
            click_value_2: clickValue2,
            click_value_3: clickValue3,
            click_value_4: clickValue4,
            click_value_5: clickValue5,
        },
    });
}
